import { styled } from '../../Utilities';
import { DocumentCardTitleBase } from './DocumentCardTitle.base';
import { getStyles } from './DocumentCardTitle.styles';
export var DocumentCardTitle = styled(DocumentCardTitleBase, getStyles, undefined, {
  scope: 'DocumentCardTitle'
});